import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=01b92154"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"
import style0 from "./AddressForm.vue?vue&type=style&index=0&id=01b92154&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b92154')) {
      api.createRecord('01b92154', component.options)
    } else {
      api.reload('01b92154', component.options)
    }
    module.hot.accept("./AddressForm.vue?vue&type=template&id=01b92154", function () {
      api.rerender('01b92154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/AccountSetup/AddressForm.vue"
export default component.exports